// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elt-wp-plugin {
  font-size: 16px;

  .instructor-list {
    position: relative;
  }

  .instructor-card {
    background-color: #fff;
    border: 0.1rem solid #ccc;
    border-radius: 8px;
    padding: 1.5rem;
    max-width: 95%;
    margin: 0 auto;
    text-align: left;
    transition: transform 0.3s ease;
  }

  .instructor-slide {
    outline: none;
  }

  .instructor-photo {
    width: 100%;
    height: 20rem;
    border-radius: 1rem;
    object-fit: cover;
    margin-bottom: 1rem;
  }

  .instructor-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .instructor-name {
    font-size: 1.8rem;
    font-weight: bold;
    font-family: serif;
    color: #664400;
    margin-bottom: 1rem;
    text-align: left;
  }

  .instructor-bio {
    font-size: 1.4rem;
    color: #333;
    line-height: 1.6;
    max-height: 6rem;
    overflow: hidden;
    position: relative;
    text-align: left;
    transition: max-height 0.3s ease;
  }

  .instructor-bio.collapsed::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2rem;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    pointer-events: none;
  }

  .instructor-bio.expanded {
    max-height: none;
  }

  .toggle-button {
    background: none;
    border: none;
    color: #2a3d86;
    cursor: pointer;
    font-size: 1rem;
    margin-top: 1rem;
  }

  .toggle-button:hover {
    text-decoration: underline;
  }

  .slick-track {
    display: flex !important; /* 必要に応じてflexを設定 */
  }

  .slick-prev, .slick-next {
    font-size: 0; /* テキストを非表示にする */
    z-index: 1;
    line-height: 0; /* テキストの高さを無効化 */
    background: transparent;
    border: none;
  }
  
  .slick-prev:before, .slick-next:before {
    font-size: 2rem; /* 矢印のサイズを変更 */
    color: rgba(100, 100, 100, 1); /* アイコン色を変更 */
    line-height: 1; /* アイコンを中央に配置 */
  }
  
  /* 矢印の位置調整 */
  .slick-prev {
    left: 0.5rem;
  }
  
  .slick-next {
    right: 0.5rem;
  }

  .instructor-name-container {
    display: flex;
    align-items: center;
    gap: 1rem; /* 名前とアイコンの間にスペースを作成 */
  }
  
  .instructor-flag {
    width: 2.4rem;
    height: 2.4rem;
  }

  /* モバイル用のスタイル */
  @media (max-width: 768px) {
    .instructor-card {
      text-align: center;
      align-items: center;
      width: 100%;
    }

    .slick-slide {
      transition: opacity 0.3s ease;
    }

    .slick-prev:before, .slick-next:before {
      font-size: 2rem; /* モバイルでのアイコンのサイズを調整 */
    }
    
    .slick-prev {
      left: 0.5rem;
    }

    .slick-next {
      right: 0.5rem;
    }

    .instructor-bio {
      max-height: 4rem;
    }

    .instructor-bio.collapsed::after {
      height: 1.5rem;
    }
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/InstructorCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;;EAEf;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,sFAAsF;IACtF,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB,EAAE,kBAAkB;EAC9C;;EAEA;IACE,YAAY,EAAE,gBAAgB;IAC9B,UAAU;IACV,cAAc,EAAE,gBAAgB;IAChC,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe,EAAE,cAAc;IAC/B,6BAA6B,EAAE,aAAa;IAC5C,cAAc,EAAE,eAAe;EACjC;;EAEA,YAAY;EACZ;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,sBAAsB;EACnC;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,eAAe;EACf;IACE;MACE,kBAAkB;MAClB,mBAAmB;MACnB,WAAW;IACb;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,eAAe,EAAE,sBAAsB;IACzC;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;IAChB;EACF;AACF","sourcesContent":[".elt-wp-plugin {\n  font-size: 16px;\n\n  .instructor-list {\n    position: relative;\n  }\n\n  .instructor-card {\n    background-color: #fff;\n    border: 0.1rem solid #ccc;\n    border-radius: 8px;\n    padding: 1.5rem;\n    max-width: 95%;\n    margin: 0 auto;\n    text-align: left;\n    transition: transform 0.3s ease;\n  }\n\n  .instructor-slide {\n    outline: none;\n  }\n\n  .instructor-photo {\n    width: 100%;\n    height: 20rem;\n    border-radius: 1rem;\n    object-fit: cover;\n    margin-bottom: 1rem;\n  }\n\n  .instructor-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n\n  .instructor-name {\n    font-size: 1.8rem;\n    font-weight: bold;\n    font-family: serif;\n    color: #664400;\n    margin-bottom: 1rem;\n    text-align: left;\n  }\n\n  .instructor-bio {\n    font-size: 1.4rem;\n    color: #333;\n    line-height: 1.6;\n    max-height: 6rem;\n    overflow: hidden;\n    position: relative;\n    text-align: left;\n    transition: max-height 0.3s ease;\n  }\n\n  .instructor-bio.collapsed::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2rem;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));\n    pointer-events: none;\n  }\n\n  .instructor-bio.expanded {\n    max-height: none;\n  }\n\n  .toggle-button {\n    background: none;\n    border: none;\n    color: #2a3d86;\n    cursor: pointer;\n    font-size: 1rem;\n    margin-top: 1rem;\n  }\n\n  .toggle-button:hover {\n    text-decoration: underline;\n  }\n\n  .slick-track {\n    display: flex !important; /* 必要に応じてflexを設定 */\n  }\n\n  .slick-prev, .slick-next {\n    font-size: 0; /* テキストを非表示にする */\n    z-index: 1;\n    line-height: 0; /* テキストの高さを無効化 */\n    background: transparent;\n    border: none;\n  }\n  \n  .slick-prev:before, .slick-next:before {\n    font-size: 2rem; /* 矢印のサイズを変更 */\n    color: rgba(100, 100, 100, 1); /* アイコン色を変更 */\n    line-height: 1; /* アイコンを中央に配置 */\n  }\n  \n  /* 矢印の位置調整 */\n  .slick-prev {\n    left: 0.5rem;\n  }\n  \n  .slick-next {\n    right: 0.5rem;\n  }\n\n  .instructor-name-container {\n    display: flex;\n    align-items: center;\n    gap: 1rem; /* 名前とアイコンの間にスペースを作成 */\n  }\n  \n  .instructor-flag {\n    width: 2.4rem;\n    height: 2.4rem;\n  }\n\n  /* モバイル用のスタイル */\n  @media (max-width: 768px) {\n    .instructor-card {\n      text-align: center;\n      align-items: center;\n      width: 100%;\n    }\n\n    .slick-slide {\n      transition: opacity 0.3s ease;\n    }\n\n    .slick-prev:before, .slick-next:before {\n      font-size: 2rem; /* モバイルでのアイコンのサイズを調整 */\n    }\n    \n    .slick-prev {\n      left: 0.5rem;\n    }\n\n    .slick-next {\n      right: 0.5rem;\n    }\n\n    .instructor-bio {\n      max-height: 4rem;\n    }\n\n    .instructor-bio.collapsed::after {\n      height: 1.5rem;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
